import { render, staticRenderFns } from "./ChurchList.vue?vue&type=template&id=02ebd85c&scoped=true&"
import script from "./ChurchList.vue?vue&type=script&lang=js&"
export * from "./ChurchList.vue?vue&type=script&lang=js&"
import style0 from "./ChurchList.vue?vue&type=style&index=0&id=02ebd85c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ebd85c",
  null
  
)

export default component.exports